import Route from 'cio/routes/base';

export default class WorkflowRoute extends Route {
  crumb() {
    return {
      name: 'Workflow',
      path: this.routeName,
    };
  }
}
